export const CASE_ITEM_TYPE = "CASE";
export const PRESENTATION_SLIDE_ITEM_TYPE = "PRESENTATION_SLIDE";

export function generateCopiedMaterialId(sourceId, existingMaterialIds = []) {
  const copyPrefix = `COPY-${sourceId}-`;
  const nextCopyNumber = existingMaterialIds.reduce((highestCopyNumber, id) => {
    const materialId = String(id || "");
    if (!materialId.startsWith(copyPrefix)) {
      return highestCopyNumber;
    }

    const copyNumber = materialId.slice(copyPrefix.length);
    if (!/^\d+$/.test(copyNumber)) {
      return highestCopyNumber;
    }

    return Math.max(highestCopyNumber, Number(copyNumber));
  }, 0);

  return `${copyPrefix}${nextCopyNumber + 1}`;
}

export function buildCopiedMaterialItem(caseDetail, index) {
  const eduCase = caseDetail.eduCases || {};
  const itemType = eduCase.itemType || caseDetail.itemType || CASE_ITEM_TYPE;
  const copiedItem = {
    itemType,
    orderNo: Number(eduCase.orderNo) || index + 1,
    comment: eduCase.comment || "",
  };

  if (itemType === PRESENTATION_SLIDE_ITEM_TYPE) {
    const presentationSlideId =
      eduCase.presentationSlideId != null
        ? eduCase.presentationSlideId
        : caseDetail.presentationSlide && caseDetail.presentationSlide.id;

    if (presentationSlideId == null) {
      throw new Error("Unable to copy a presentation slide without an id");
    }

    copiedItem.presentationSlideId = Number(presentationSlideId);
    return copiedItem;
  }

  const caseId =
    eduCase.caseId != null
      ? eduCase.caseId
      : caseDetail.caseInfo && caseDetail.caseInfo.caseId;

  if (caseId == null) {
    throw new Error("Unable to copy a tumor case without a case id");
  }

  copiedItem.caseId = Number(caseId);
  return copiedItem;
}
